import { createContext, useContext, useRef, useMemo } from "react";
import { useQuery, useMutation } from "@tanstack/react-query";
import {
  updateWorkByItem,
  addWorkItem,
  getWorkByItem,
} from "../../api/carreers";
import useToaster from "../../components/alert";
import Const from "../../utils/constant";
import { useNavigate, useParams } from "react-router-dom";
import { useSearchParams } from "react-router-dom";
import slugify from "slugify";

const PageContext = createContext();

export const PageProvider = ({ children }) => {
  const navigate = useNavigate();

  const AddWorkArray = useRef();
  const toaster = useToaster();
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const itemId = searchParams.get("itemId");

  const getWorkQuery = useQuery({
    queryKey: ["works", id, itemId],
    queryFn: getWorkByItem,
    enabled: !!itemId,
  });

  const updateWorkQuery = useMutation({ mutationFn: updateWorkByItem });
  const addWorkItemQuery = useMutation({ mutationFn: addWorkItem });

  const initialValues = useMemo(() => {
    const workAddData = getWorkQuery?.data?.data || {};
    return {
      careers: {
        job_name: workAddData?.job_name || "",
        job_description: workAddData?.job_description || "",
        responsiblities: workAddData?.responsiblities || {
          title: "",
          description: "",
        },
        requirements: workAddData?.requirements || {
          title: "",
          description: "",
        },
        slug_url: workAddData?.slug_url || "",
        assessment_file: workAddData?.assessment_file || "",
        cta_label: workAddData?.cta_label || "",
      },
    };
  }, [getWorkQuery]);

  // const handleSubmit = async (values) => {
  //   const payload = {
  //     id,
  //     job_name: values?.careers.job_name || "",
  //     job_description: values?.careers.job_description || "",
  //     responsiblities: values?.careers?.responsiblities || [{ title: "" }],
  //     requirements: values?.careers?.requirements,
  //     slug_url: slugify(values?.careers.job_name, {
  //       lower: true,
  //       strict: true,
  //     }),
  //     assessment_file: values?.careers?.assessment_file || "",
  //     cta_label: values?.careers?.cta_label || "",
  //   };

  //   if (itemId) {
  //     payload.itemId = itemId;
  //     updateWorkQuery.mutate(payload, {
  //       onSuccess: () => {
  //         toaster.success(
  //           Const.MESSAGES.SUCCESS,
  //           Const.MESSAGES.DATA_IS_UPDATED_SUCCESSFULLY
  //         );
  //       },
  //     });
  //     return;
  //   }
  //   addWorkItemQuery.mutate(payload, {
  //     onSuccess: () => {
  //       toaster.success(
  //         Const.MESSAGES.SUCCESS,
  //         Const.MESSAGES.DATA_IS_UPDATED_SUCCESSFULLY
  //       );
  //     },
  //   });
  // };

  const handleSubmit = async (values) => {
    const payload = {
      id,
      job_name: values?.careers.job_name || "",
      job_description: values?.careers.job_description || "",
      responsiblities: values?.careers?.responsiblities || [{ title: "" }],
      requirements: values?.careers?.requirements,
      slug_url: slugify(values?.careers.job_name, {
        lower: true,
        strict: true,
      }),
      assessment_file: values?.careers?.assessment_file || "",
      cta_label: values?.careers?.cta_label || "",
    };
  
    const onSuccessCallback = () => {
      toaster.success(
        Const.MESSAGES.SUCCESS,
        Const.MESSAGES.DATA_IS_UPDATED_SUCCESSFULLY
      );
      navigate("/careers"); 
      window.location.reload(); 
    };
  
    if (itemId) {
      payload.itemId = itemId;
      updateWorkQuery.mutate(payload, {
        onSuccess: onSuccessCallback,
      });
      return;
    }
  
    addWorkItemQuery.mutate(payload, {
      onSuccess: onSuccessCallback,
    });
  };
  

  const handleNewWorkAdd = () => {
    AddWorkArray.current.push({ image_link: "" });
  };

  const handleNewWorkDelete = (index) => () => {
    AddWorkArray.current.remove(index);
  };
  return (
    <PageContext.Provider
      value={{
        initialValues,
        handleNewWorkDelete,
        AddWorkArray,
        handleNewWorkAdd,
        getWorkQuery,
        handleSubmit,
      }}>
      {children}
    </PageContext.Provider>
  );
};

export const useAddWorkProvider = () => {
  return useContext(PageContext);
};
